import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import nodeinstance from "../../nodeInstance";

const getSadaadData = createAsyncThunk("api/sadaad", async (token, type) => {
    try {
        const response = await nodeinstance.get("/sadaad", {
            headers: { Authorization: `Bearer ${token}` },
        });
        return response.data.data;
    } catch (e) {
        throw new Error(e.message);
    }
});


const SadaadDataSlice = createSlice({
    name: "sadaad",
    initialState: {
        data: null,
        error: "",
        status: false,
        isLoading: false,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getSadaadData.fulfilled, (state, action) => {
                state.data = action.payload;
                state.isLoading = false;
                state.status = true;
            })
            .addCase(getSadaadData.pending, (state, action) => {
                state.isLoading = true;
            })
            .addCase(getSadaadData.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.error.message;
            });
    },
});

export { getSadaadData };
export default SadaadDataSlice.reducer;
